import { createApi } from '../createApi';
import * as dummy from '../dummy/reviews';
import * as real from '../api/reviews';

const api = createApi(dummy, real);

/** 리뷰 서비스 — API_DOCS: 11. 리뷰 / 25. 관리자 - 리뷰 */
export const reviewService = {
  /* 서비스 (유저용) */
  getStats: api.getReviewStats,
  getList: api.getReviews,
  create: api.createReview,
  update: api.updateReview,
  delete: api.deleteReview,

  /* 관리자 */
  adminGetList: api.getAdminReviews,
  adminGetById: api.getAdminReviewById,
  adminUpdateStatus: api.updateAdminReviewStatus,
  adminDelete: api.deleteReview,
};
